module.exports = __webpack_public_path__ + "img/RE.9febc95b.png";